import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { HAS_INSTANT_DISCOUNT, USE_PARITY } from '../../../../../constants';

import { doRewriteUrl } from '../../../../../services/interstitiel/actions';

import { getConfirmRedirection } from '../../../../../utils/plebicardUtils';
import { formatAmountCurrency, formatAmountParity, getParityTotal } from '../../../../../utils';

import { VALIDATED } from '../../../../../services/checkout/constants';
import FixedValueBloc from './FixedValueBloc';
import FreeValueBloc from './FreeValueBloc';

const ConfirmationEbonPageMessageBloc = ({
    partnerId,
    partnerName,
    sessionEmail,
    confirmedOrder,
    ebonOrderState,
    urlRewritten,
    doRewriteUrl
}) => {
    const redirection = getConfirmRedirection();
    const redirectUri = redirection ? redirection.redirectUri : undefined;
    const redirectLabel =
        redirection && redirection.label
            ? redirection.label
            : redirectUri
            ? redirectUri.replace('https://', '').replace('http://', '')
            : undefined;

    const ebonDiscount = confirmedOrder && confirmedOrder.ebonDiscount;
    const ebonList = confirmedOrder && confirmedOrder.ebonList;

    const effectiveDiscount =
        ebonDiscount && (USE_PARITY ? ebonDiscount.parity : ebonDiscount.cashback);
    const fixed = effectiveDiscount && effectiveDiscount.fixed.value;
    const percent = effectiveDiscount && effectiveDiscount.percent.value;
    const amountCashback = fixed > 0 ? fixed : percent;

    const doEbonListTotal = ebonList => {
        return ebonList.reduce((acc, curr) => acc + curr.facialValue, 0);
    };
    const doEbonListTotalCashbackAmount = ebonList => {
        const ebonListTotal = doEbonListTotal(ebonList);
        const totalCashbackAmount = (ebonListTotal * amountCashback) / 100;
        const normalizedCashBackNumber = +totalCashbackAmount.toFixed(2);
        return normalizedCashBackNumber;
    };
    const doEbonListTotalCashbackAmountParity = ebonList => {
        const ebonListTotal = doEbonListTotal(ebonList);
        const totalCashbackAmount = getParityTotal(ebonListTotal, amountCashback);
        const normalizedCashBackNumber = Number(totalCashbackAmount.toFixed(2));
        return normalizedCashBackNumber;
    };
    const ebonListTotalCashbackAmount = ebonList
        ? USE_PARITY
            ? doEbonListTotalCashbackAmountParity(ebonList)
            : doEbonListTotalCashbackAmount(ebonList)
        : 0;

    const amount = USE_PARITY
        ? formatAmountParity(ebonListTotalCashbackAmount)
        : formatAmountCurrency(ebonListTotalCashbackAmount);

    /* Start Retagage */
    useEffect(() => {
        HAS_INSTANT_DISCOUNT &&
            ebonOrderState &&
            ebonOrderState === VALIDATED &&
            partnerId &&
            doRewriteUrl(partnerId, -1, 0, '', 'inconnu', false, false, null, null);
    }, [partnerId]);
    /* End Retagage */

    return ebonList && ebonList.length > 0 ? (
        <FixedValueBloc
            partnerName={partnerName}
            sessionEmail={sessionEmail}
            urlRewritten={urlRewritten}
            redirectUri={redirectUri}
            redirectLabel={redirectLabel}
            amount={amount}
        />
    ) : (
        <FreeValueBloc
            partnerName={partnerName}
            sessionEmail={sessionEmail}
            urlRewritten={urlRewritten}
            redirectUri={redirectUri}
            redirectLabel={redirectLabel}
            amount={amount}
        />
    );
};

ConfirmationEbonPageMessageBloc.propTypes = {
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    sessionEmail: PropTypes.string,
    confirmedOrder: PropTypes.object,
    ebonOrderState: PropTypes.string
};

const mapStateToProps = state => {
    return {
        urlRewritten: state.interstitiel.urlRewritten
    };
};

const mapDispatchToProps = {
    doRewriteUrl
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationEbonPageMessageBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/message/ConfirmationEbonPageMessageBloc.js